export class ProcListModel {
    procedure_no: number
    procedure_code: string
    procedure_desc: string
    procedure_price: number
    procedure_clinic: number

    constructor(
        procedure_no: number,
        procedure_code: string,
        procedure_desc: string,
        procedure_price: number = 0,
        procedure_clinic: number = 0
    ) {
        this.procedure_no = procedure_no
        this.procedure_code = procedure_code
        this.procedure_desc = procedure_desc
        this.procedure_price = procedure_price
        this.procedure_clinic = procedure_clinic
    }
} 